import React from 'react'
import { Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { IconSadSuitcase } from '@s4l/icons/IconSadSuitcase'

import styles from './styles.module.css'

function NoAvailability() {
  const { i18n } = useS4LContext()
  return (
    <div className={styles.container}>
      <IconSadSuitcase size={64} />
      <Typography variant="body" size="l">
        {i18n.formatMessage({ id: 'detail.no-availability' })}
      </Typography>
    </div>
  )
}

NoAvailability.displayName = 'RoomConfigurator.NoAvailability'

export default NoAvailability
